<template>
  <div
    ref="scroller"
    class="text-white bg-white"
    :style="`height:${height}px;width:100%;overflow-x:hidden;overflow-y:auto;scroll-behavior: smooth;`"
  >
    <div class="row full-width justify-center content-center">
      <div class="column" :style="`width:calc(${columnWidth}px - 2px); margin: 0 1px;`">
        <DFullScreenCarouselPickerTile
          v-for="image in evenImages"
          :key="`even${image.src}`"
          :image="image"
          @click="tileClick"
          :virtualtour="virtualtour"
        />
      </div>
      <div style="border-left: 1px solid #fff"></div>
      <div class="column" :style="`width:calc(${columnWidth}px - 2px); margin: 0 1px;`">
        <DFullScreenCarouselPickerTile
          v-for="image in oddImages"
          :key="`odd${image.src}`"
          :image="image"
          @click="tileClick"
          :virtualtour="virtualtour"
        />
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "../../d-card-mixins";
import DFullScreenCarouselPickerTile from "./DFullScreenCarouselPickerTile.vue";
export default {
  name: "DFullScreenCarouselPickerScroller",
  mixins: [mixin],
  components: { DFullScreenCarouselPickerTile },
  props: {
    behavior: {
      type: String,
      default: "agent",
    },
    height: {
      type: Number,
      required: true,
    },
    images: {
      type: Array,
      default: () => [],
    },
    virtualtour: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      columnWidth: 0,
      lastPosition: 0,
    };
  },
  computed: {
    oddImages: {
      get() {
        return this.images.filter((v, i) => i % 2);
      },
    },
    evenImages: {
      get() {
        return this.images.filter((v, i) => !(i % 2));
      },
    },
    scrollTop: {
      get() {
        if (this.behavior === "consumer") {
          return this.$cardStore.get(
            `componentOverlay.fscstate.pickerScrollTop`
          );
        }
      },
      set(val) {
        if (this.behavior === "consumer") {
          this.$cardStore.set(`componentOverlay.fscstate.pickerScrollTop`, val);
        }
      },
    },
  },
  mounted() {
    this.renderScroller();
  },
  beforeDestroy() {
    this.$refs.scroller.removeEventListener("scroll", this.scrollEvent);
  },
  methods: {
    renderScroller() {
      const scrollerRect = this.$refs.scroller.getBoundingClientRect();
      const hasScrollbar = this.images.length > 6;
      this.columnWidth = hasScrollbar
        ? scrollerRect.width / 2 - 7
        : scrollerRect.width / 2 - 3;
      this.$refs.scroller.addEventListener("scroll", this.scrollEvent);
      this.$watch("scrollTop", (val) => {
        this.$refs.scroller.scrollTop = val;
      });
    },
    scrollEvent(ev) {
      clearTimeout(this.scrollTimeout);
      this.lastPosition = ev.target.scrollTop;
      this.scrollTimeout = setTimeout(() => {
        this.scrollTop = this.lastPosition;
      }, 400);
    },
    tileClick(index) {
      this.$emit("tileClick", index);
    },
  },
};
</script>
<style scoped>
/* width */
::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #aaa;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
</style>
